import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import {
  LANGMI_PRIVACY_LANGUAGES,
  LANGMI_PRIVACY_TRANSLATIONS,
  LangmiPrivacyTranslation
} from '../../../../data/langmi/langmi-privacy-i18n.data';

/**
 * /langmi/privacy-policy/:lang - the LangMi Privacy Policy in one of the app's other languages (2026-09-25).
 * The App Store listing of each language links here. An unknown code goes to the English original.
 */
@Component( {
  selector: 'app-langmi-privacy-localized-page',
  templateUrl: './langmi-privacy-localized-page.component.html',
  styleUrls: [ './langmi-privacy-localized-page.component.scss' ]
} )
export class LangmiPrivacyLocalizedPageComponent implements OnInit, OnDestroy {

  LANGUAGES = LANGMI_PRIVACY_LANGUAGES;

  lang = '';

  page?: LangmiPrivacyTranslation;

  private subscription?: Subscription;

  constructor( private route: ActivatedRoute, private router: Router, private titleService: Title ) {
    // Intentionally Blank
  }

  ngOnInit(): void {
    this.subscription = this.route.paramMap.subscribe( params => {
      const lang = ( params.get( 'lang' ) || '' ).toLowerCase();
      const page = LANGMI_PRIVACY_TRANSLATIONS[ lang ];
      if ( !page ) {
        this.router.navigate( [ '/langmi/privacy-policy' ], { replaceUrl: true } );
        return;
      }
      this.lang = lang;
      this.page = page;
      // the navigation guard set the English title of the base route; the page shows its own language
      this.titleService.setTitle( page.title );
    } );
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
